export default (that) => [
  {
    width: 40,
    align: 'center',
    type: 'seq',
    merge: true
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号',
    field: 'orderGoodsNo',
    width: 140,
    align: 'center',
    mergeByKey: true,
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    minWidth: 140,
    align: 'left',
    headerAlign: 'center',
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsName') || '产品名称',
    field: 'orderGoodsDisplayName',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_number') || '产品总数',
    field: 'orderGoodsQty',
    width: 80,
    align: 'center',
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_inPackageQty') || '装箱入数',
    field: 'inPackageQty',
    headerAlign: 'center',
    align: 'center',
    width: 70,
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_boxQty') || '箱数',
    field: 'boxQty',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    merge: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_goods_label_price') || '价格',
    field: 'orderGoodsPrice',
    width: 80,
    align: 'center',
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
